import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const SignaturePad = (props, { onSave, onClear, setCurrentStep }) => {
  const signatureRef = useRef(null);
  const handleSave = async () => {
    if (signatureRef.current.isEmpty()) {
      alert("Please provide your signature");
      return;
    }
    const dataURL = signatureRef.current.toDataURL();
    console.log(dataURL);
    props.submitForm(dataURL);
  };

  const handleClear = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <SignatureCanvas
        ref={signatureRef}
        penColor="black"
        canvasProps={{
          width: 300,
          height: 200,
          className: "signature-canvas",
          style: { backgroundColor: "#f0f0f0" },
        }}
      />
      <div style={{ marginTop: "10px" }}>
        <Button
          variant="outlined"
          onClick={handleClear}
          style={{ marginRight: "10px" }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          style={{ marginRight: "10px" }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

SignaturePad.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default SignaturePad;
